import React, { useState } from "react";
import { Route, Switch } from "react-router-dom";
import { RoutesPage, RoutesAuth, RoutesUser } from "../Route/route";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import UserHeader from "../Component/UserHeader";
import NotFound from "../Component/NotFound";
import { useEffect } from "react";
import { agent } from "../utils/agent";
import * as API from "../utils/apiPath";

const RouteWithHeader = ({ component: Component, ...rest }) => {
  const url = window.location.href.toLowerCase();
  const contains = ['!', '!#', '#', '#!'].some((char) => url.includes(char));
  const newUrl = url.replace('#', '').replace('!', '').replace('!#', '').replace('#!', '');
  useEffect(() => {
    if (window.location.search.includes('?_escaped_fragment_')) {
      const updatedSearch = window.location.search.replace('?_escaped_fragment_', '');

      const updatedURL = `${window.location.origin}${window.location.pathname}${updatedSearch}${window.location.hash}`;

      window.history.replaceState(null, null, updatedURL);
    }
    if (contains) {
      window.history.replaceState(null, null, newUrl)
    }
  }, []);

  const substrings = ['mahadewi-mentoring', 'scs-wit-mentoring'];
  const result = substrings.some(substring => url?.includes(substring));
  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          {result ? null : <Header />}
          <Component {...props} title={rest.title} />
          {result ? null : <Footer />}

        </>
      )}
    />
  );
};

const RouteWithAuth = ({ component: Component, ...rest }) => {
  const url = window.location.href;
  const contains = ['!', '!#', '#', '#!'].some((char) => url.includes(char));
  const newUrl = url.replace('#', '').replace('!', '').replace('!#', '').replace('#!', '');
  useEffect(() => {
    if (window.location.search.includes('?_escaped_fragment_')) {
      const updatedSearch = window.location.search.replace('?_escaped_fragment_', '');

      const updatedURL = `${window.location.origin}${window.location.pathname}${updatedSearch}${window.location.hash}`;

      window.history.replaceState(null, null, updatedURL);
    }
    if (contains) {
      window.history.replaceState(null, null, newUrl)
    }
  }, []);
  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          <Component {...props} title={rest.title} />
        </>
      )}
    />
  );
};

const RouteWithSidebar = ({ component: Component, ...rest }) => {
  const url = window.location.href;
  const contains = ['!', '!#', '#', '#!'].some((char) => url.includes(char));
  const newUrl = url.replace('#', '').replace('!', '').replace('!#', '').replace('#!', '');
  useEffect(() => {
    if (window.location.search.includes('?_escaped_fragment_')) {
      const updatedSearch = window.location.search.replace('?_escaped_fragment_', '');

      const updatedURL = `${window.location.origin}${window.location.pathname}${updatedSearch}${window.location.hash}`;

      window.history.replaceState(null, null, updatedURL);
    }
    if (contains) {
      window.history.replaceState(null, null, newUrl)
    }
  }, []);
  return (
    <Route
      {...rest}
      render={(props) => (
        <div className="main-body">
          <div className="page-wrapper">
            <UserHeader />
            <Component {...props} title={rest.title} />
          </div>
        </div>
      )}
    />
  );
};

const Index = (props) => {
  const [showMarqueeState, setShowMarqueeState] = useState(false);

  //   const {
  //   setting: { module_data },
  // } = props;

  console.log('props', props)


  const [settings, setSettings] = useState({
    start_date_time: null,
    end_date_time: null,
    notification_message: "",
    site_maintenance_mode: false,
    site_maintenance_message: "",
    site_maintenance_notification: false,
  });

  useEffect(() => {
    // const url =
    //   process.env.REACT_APP_API_BASE_URL + API.GET_MAINTAINENCE_SETTING;
    agent
      .get(API.GET_MAINTAINENCE_SETTING)
      .then((response) => {
        const data = response.data?.data || {};
        console.log("data in setting api:", data);
        setSettings({
          start_date_time: data.start_date_time,
          end_date_time: data.end_date_time,
          notification_message: data.notification_message,
          site_maintenance_mode: data.site_maintenance_mode,
          site_maintenance_message: data.site_maintenance_message,
          site_maintenance_notification: data.site_maintenance_notification,
        });
      })
      .catch((error) => {
        console.error("Error fetching settings:", error);
      });
  }, []);

const showMarquee = () => {
  if (settings.site_maintenance_notification != 1) return false;

  const now = new Date();
  const from = new Date(settings.start_date_time);
  const to = new Date(settings.end_date_time);

  return now >= from && now <= to && !!settings.notification_message;
};

  useEffect(() => {
    console.log("Updating marquee state based on settings", showMarquee());
    setShowMarqueeState(showMarquee());
  }, [settings]);

  return (
    <>
    {showMarqueeState && (
        <div className="marquee-wrapper">
          <div
            style={{
              background: "#f0f8ff",
              whiteSpace: "nowrap",
              overflow: "hidden",
              fontWeight: "bold",
              padding: "10px",
              color: "#000"
            }}
          >
            {console.log("fffffffffffff")}
            <div
            className="marquee-text"
            >
              {settings.notification_message}
            </div>
            <style>{`
            @keyframes marquee {
              0% { transform: translateX(100%) }
              100% { transform: translateX(-100%) }
            }
          `}</style>
          </div>
        </div>
      )}
    <Switch>
      {RoutesPage.map((route, index) => (
        <RouteWithHeader
          key={index}
          exact
          path={route.path}
          component={route.component}
          title={route.title}
        />
      ))}
      {RoutesAuth.map((route, index) => (
        <RouteWithAuth
          key={index}
          exact
          path={route.path}
          component={route.component}
          title={route.title}
        />
      ))}
      {RoutesUser.map((route, index) => (
        <RouteWithSidebar
          key={index}
          exact
          path={route.path}
          component={route.component}
          title={route.title}
        />
      ))}
      <RouteWithHeader
        key={''}
        exact
        path={'*'}
        component={NotFound}
        title={'Not Found'}
      />
    </Switch>
    </>

  );
};

export default Index;
